<template>
  <div class="partners">
    <h2>Our partners</h2>
    <div class="partners-pictures">
      <a href="https://research.qut.edu.au/designlab/" target="_blank" @click="logPartnerClicks('QUT')">
        <div
          class="partner"
          style="
            background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/DL-Blue-Logo-white-background.jpg');
          "
        ></div>
      </a>
      <a href="https://cbcs.centre.uq.edu.au/" target="_blank" @click="logPartnerClicks('UQ')">
        <div
          class="partner"
          style="background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/UQlogo-Purple-rgb.png')"
        ></div>
      </a>
    </div>
    <p>To learn more about our partners <a href="https://www.wwf.org.au/news/blogs/thanks-to-our-my-backyard-partners" target="_blank">click here</a></p>
  </div>
</template>
  
<script>
export default {
  name: "Partners",
  // data() {},
  methods: {
    async logPartnerClicks(partner) {
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Our Partners Clicks",
        eventProperties: { "Partner Name ": partner },
      });
    } 
  }
};
</script>

<style scoped>
.partners {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 24px;
  background-color: #fbfbfa;
}

h2 {
  margin: 0;
}

.partners .partners-pictures {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.partners .partners-pictures .partner {
  width: 250px;
  height: 80px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 30px;
}

@media only screen and (max-width: 600px) {
  .partners-pictures {
    flex-direction: column;
  }
}

/* Style from elcom */
h1, h2, h3 {
  font-family: "WWF",sans-serif;
  position: relative;
  z-index: 1;
}

h2 {
  font-size: 50px;
}
@media only screen and (max-width: 64em) {
  h2 {
    font-size: 44px;
    line-height: 46px;
  }
}
@media only screen and (max-width: 40em) {
  h2 {
    font-size: 34px;
    line-height: 36px;
  }
}

a {
  color: #f37043;
}

p {
  font-family: 'Lato',sans-serif;
  position: relative;
  margin: 0;
  font-size: 16px;
}

@media only screen and (max-width: 40em) {
  p {
    font-size: 15px;
    line-height: 23px;
  }
}
/* END */
</style>


// WEBPACK FOOTER //
// Partners.vue?77b1f7b4